/** Stroke icons from the design handoff (24x24, round caps). Decorative: the button carries the name. */
const PATHS = {
  back: "M15 5l-7 7 7 7",
  invite: "M5 8a4 4 0 1 0 8 0a4 4 0 1 0-8 0M2 21c0-4 3-6 7-6s7 2 7 6M19 8v6M16 11h6",
  eye: "M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12zM9 12a3 3 0 1 0 6 0a3 3 0 1 0-6 0",
  wifiOff:
    "M2 8.5a16 16 0 0 1 6.2-3.3M12 5c3.7 0 7.1 1.3 10 3.5M5 12.5a11 11 0 0 1 3.6-2.3M12 9.5c2.6 0 5 .9 7 2.5M8.5 16a5 5 0 0 1 7 0M12 20h.01M3 3l18 18",
  bot: "M7 8h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3zM12 8V4M8 14h.01M16 14h.01M9 17h6",
  crown: "M3 18h18l-1.5-9-4.5 4-3-7-3 7-4.5-4z",
  plus: "M12 5v14M5 12h14",
  close: "M6 6l12 12M18 6L6 18",
  smile:
    "M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0M8.5 14.5s1.3 2 3.5 2 3.5-2 3.5-2M9 9.5h.01M15 9.5h.01",
  exit: "M10 17l-5-5 5-5M5 12h11a4 4 0 0 1 0 8h-1",
  refresh: "M20 12a8 8 0 1 1-3-6.2M20 4v5h-5",
  trophy: "M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0zM7 6H4a3 3 0 0 0 3 4M17 6h3a3 3 0 0 1-3 4",
  sound: "M4 9h4l5-4v14l-5-4H4zM16.5 9a4 4 0 0 1 0 6M19 6.5a8 8 0 0 1 0 11",
  soundOff: "M4 9h4l5-4v14l-5-4H4zM16.5 9.5l5 5M21.5 9.5l-5 5",
  help: "M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0M9.2 9.3a3 3 0 0 1 5.8 1c0 2-3 2.5-3 4M12 17h.01",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size = 24,
  strokeWidth = 2.2,
  className = "",
}: {
  name: IconName;
  size?: number;
  strokeWidth?: number;
  className?: string;
}) {
  const filled = name === "crown";
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill={filled ? "currentColor" : "none"}
      height={size}
      stroke={filled ? "none" : "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      viewBox="0 0 24 24"
      width={size}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
